// keep the decimal part supply decimal parts over 0
export const toPercent = (num: number, decimalParts = 1) =>
  (num * 100).toFixed(decimalParts);

// Add commas to numbers (e.g. 31102 to 31,102)
export function numberWithCommas(x: number) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
